export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/jqCMBhhMhxfQbvNCepQkK1/PAGINA_1.png',
    alt: "Pagina di esempio Ogni parte dell'acino dà qualcosa al vino: anatomia dell'acino con buccia, polpa, vinaccioli e raspo",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ox56fikoPZKTLGgPbMTBrA/PAGINA_2.png',
    alt: 'Pagina di esempio I grandi stili del vino: una mappa degli stili, dai bianchi fermi ai vini liquorosi',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/63wTGnC8QyZ8VGuspMSnDF/PAGINA_3.png',
    alt: 'Pagina di esempio La piramide della qualità italiana: DOCG, DOC, IGT e Vino',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3cjCJZ8gnXgRTRqmpc8NKd/PAGINA_4.png',
    alt: "Pagina di esempio Il colore racconta età e stile: l'esame visivo di bianchi, rossi e rosati",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6aH879m1K5u5YAhfDwXvQT/PAGINA_5.png',
    alt: 'Pagina di esempio Ogni vino ha la sua temperatura: temperature di servizio dagli spumanti ai rossi strutturati',
  },
];
